export const fetchBlogs = async () => {
    try {
      // http://localhost:5000
      const response = await fetch('https://blog-swipe-backend.vercel.app/getAllBlogs', {
        method: 'GET',
      });
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to fetch blogs');
      }
  
      const result = await response.json();
      console.log("Blog result:", result);
      return result; // Return the blog data
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  };
  